<template>
  <form id="app" @submit.prevent="send()" novalidate>
    <div class="mb-1">
      <p class="form-text text-muted float-right">* Required</p>
      <h6 class="font-weight-bold">
        Participation in the ComLine Face2Face 2026 event
      </h6>
      <!-- <div class="custom-control custom-radio">
        <input type="radio" id="participation-yes-28" name="participation" class="custom-control-input" value="ja-26-03" checked v-model="teilnahme">
        <label class="custom-control-label" for="participation-yes-28">Yes, I'm arriving on March 26th 2025 (Check-in from 4 pm)<b >&nbsp;Limited Space!</b></label>
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="participation-yes-29" name="participation" class="custom-control-input" value="ja-27-03" v-model="teilnahme">
        <label class="custom-control-label" for="participation-yes-29">Yes, I'm arriving on March 27th 2025 (Check-in until 12 pm)</label>
      </div> -->
    </div>
    <div class="mb-5">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="salutation">Salutation *</label>
            <select
              class="custom-select"
              name="salutation"
              id="salutation"
              required
              v-model="anrede"
              @change="salutation()"
              ref="salutation"
            >
              <option disabled selected value="">Please select</option>
              <option></option>
              <option value="Mrs">Mrs</option>
              <option value="Mr">Mr</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="name">Name *</label>
            <input
              type="text"
              class="form-control"
              name="name"
              id="name"
              @input="name()"
              ref="firstname"
              required
              v-model="vorname"
            />
            <div class="invalid-feedback">Please fill</div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="surname">Surname *</label>
            <input
              type="text"
              class="form-control"
              name="surname"
              id="surname"
              @input="surname()"
              ref="surname"
              required
              v-model="nachname"
            />
            <div class="invalid-feedback">Please fill</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="email">E-Mail-Address *</label>
            <input
              type="email"
              class="form-control"
              name="email"
              id="email"
              @input="mail()"
              ref="mail"
              required
              v-model="email"
            />
            <div class="invalid-feedback">Please fill</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="company">Company *</label>
            <input
              type="text"
              class="form-control"
              name="company"
              id="company"
              @input="company()"
              ref="company"
              required
              v-model="firma"
            />
            <div class="invalid-feedback">Please fill</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <label for="comment">Comment</label>
          <textarea
            class="form-control"
            name="comment"
            id="comment"
            rows="8"
            v-model="bemerkung"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="mb-5">
      <h4>Do you have any questions or wishes?</h4>
      <table class="mt-3">
        <tr>
          <td>E-Mail:</td>
          <td>
            <a href="mailto:face2face@comline-shop.de"
              >face2face@comline-shop.de</a
            >
          </td>
        </tr>
        <!-- <tr>
          <td>Telefon:</td>
          <td><a href="tel:046177303502">0461 77303-502</a></td>
        </tr> -->
      </table>
    </div>

    <div class="mb-5">
      <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            name="privacypolicy"
            id="privacypolicy"
            @change="confirmationAndPrivacy()"
            ref="confirmationAndPrivacy"
            required
            v-model="teilnahme"
          />
          <label class="custom-control-label" for="privacypolicy"
            >Yes, I hereby confirm my participation, my arrival on March 11th
            and accept the
            <a
              href="https://www.comline-shop.de/privacy-policy/?lang=en"
              target="_blank"
              >privacy policy</a
            >. *</label
          >
        </div>
      </div>
      <button
        type="submit"
        class="btn btn-primary"
        id="form-submit"
        v-if="!isSaved"
      >
        <div
          class="spinner-border spinner-border-sm"
          id="spinner"
          v-if="clickedSend"
        ></div>
        Send registration
      </button>
      <div class="alert alert-success" v-if="isSaved && clickedSend">
        Registration successful.
      </div>
      <div class="alert alert-danger" v-if="isntSaved && clickedSend">
        Something went wrong.
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "RegistrationViewEN",
  mounted() {
    window.console.log("log now");
  },
  data() {
    return {
      teilnahme: false,
      anrede: "",
      vorname: "",
      nachname: "",
      email: "",
      firma: "",
      bemerkung: "",
      sendState: "",
      sendSuccess: "",
      datenschutz: false,
      clickedSend: false,
      isSaved: false,
      isntSaved: false,
      isntComplete: [],
    };
  },
  watch: {
    teilnahme: function (newVal) {
      if (newVal === true) {
        this.datenschutz = true;
      }
    },
  },
  methods: {
    confirmationAndPrivacy: function () {
      if (this.teilnahme === false) {
        this.$refs.confirmationAndPrivacy.classList.add("is-invalid");
      } else {
        this.$refs.confirmationAndPrivacy.classList.remove("is-invalid");
        this.deleteEvent("Teilnahme");
      }
    },
    salutation: function () {
      if (this.anrede === "") {
        this.$refs.salutation.classList.add("is-invalid");
      } else {
        this.$refs.salutation.classList.remove("is-invalid");
        this.deleteEvent("Salutation");
      }
    },
    name: function () {
      if (this.vorname === "") {
        this.$refs.firstname.classList.add("is-invalid");
      } else {
        this.$refs.firstname.classList.remove("is-invalid");
        this.deleteEvent("Name");
      }
    },
    surname: function () {
      if (this.nachname === "") {
        this.$refs.surname.classList.add("is-invalid");
      } else {
        this.$refs.surname.classList.remove("is-invalid");
        this.deleteEvent("Surname");
      }
    },
    mail: function () {
      if (this.email === "") {
        this.$refs.mail.classList.add("is-invalid");
      } else {
        this.$refs.mail.classList.remove("is-invalid");
        this.deleteEvent("Email address");
      }
    },
    company: function () {
      if (this.firma === "") {
        this.$refs.company.classList.add("is-invalid");
      } else {
        this.$refs.company.classList.remove("is-invalid");
        this.deleteEvent("Company");
      }
    },
    // privacy: function () {
    //   if (!this.datenschutz) {
    //     this.$refs.privacy.classList.add("is-invalid");
    //   } else {
    //     this.$refs.privacy.classList.remove("is-invalid");
    //     this.deleteEvent("privacy policy");
    //   }
    // },
    deleteEvent: function (event) {
      this.isntComplete = this.isntComplete.filter((word) => word !== event);
    },
    checkInput: function () {
      this.salutation();
      this.name();
      this.surname();
      this.mail();
      this.company();
      this.confirmationAndPrivacy();

      this.isntComplete = [];
      if (this.teilnahme !== true) {
        this.isntComplete.push("Teilnahme");
      }
      if (this.datenschutz !== true) {
        this.isntComplete.push("privacy policy");
      }
      if (this.anrede === "") {
        this.isntComplete.push("Salutation");
      }
      if (this.vorname === "") {
        this.isntComplete.push("Name");
      }
      if (this.nachname === "") {
        this.isntComplete.push("Surname");
      }
      if (this.email === "") {
        this.isntComplete.push("Email address");
      }
      if (this.firma === "") {
        this.isntComplete.push("Company");
      }
      if (
        !this.isntComplete.length &&
        this.sendState !== true &&
        this.sendSuccess !== true
      ) {
        return true;
      } else {
        return false;
      }
    },
    send: function () {
      if (this.checkInput() === true) {
        this.clickedSend = true;
        this.$firestore
          .collection("registrierung2026")
          .add({
            teilnahme: this.teilnahme,
            anrede: this.anrede,
            bemerkung: this.bemerkung,
            datenschutz: this.datenschutz,
            email: this.email,
            firma: this.firma,
            nachname: this.nachname,
            vorname: this.vorname,
            lang: "EN",
            createdAt: new Date(),
          })
          .then(() => {
            this.isSaved = true;
          })
          .catch((error) => {
            window.console.error(error);
          });
      }
    },
  },
};
</script>

<style scoped>
#app {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: left;
  color: #505153;
}

.btn-primary {
  background-color: rgba(64, 137, 201, 1);
  border-color: transparent;
}
.btn-primary:hover {
  color: #fff;
  background-color: #286090;
  border-color: #204d74;
}

a {
  color: rgba(64, 137, 201, 1);
}
a:hover {
  color: #286090;
}
</style>
